import { CacheProvider } from "@emotion/react";
import createCache from "@emotion/cache";
// import { prefixer } from "stylis";
import rtlPlugin from "stylis-plugin-rtl";

interface RtlProviderProps {
  children: React.ReactNode;
}

export default function RtlProvider({ children }: RtlProviderProps) {
  const cacheRtl = createCache({
    key: "muirtl",
    // stylisPlugins: [prefixer, rtlPlugin],
    stylisPlugins: [rtlPlugin],
  });

  return <CacheProvider value={cacheRtl}>{children}</CacheProvider>;
}